import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

type DashboardTooltipItem = {
  color?: string;
  label: ReactNode;
  value: ReactNode;
};

type DashboardTooltipProps = {
  footer?: ReactNode;
  items: DashboardTooltipItem[];
  title?: ReactNode;
};

export default function DashboardTooltip({
  footer,
  items,
  title,
}: DashboardTooltipProps) {
  const theme = useTheme();

  return (
    <Paper variant="outlined" sx={{ boxShadow: theme.shadows[2], padding: 1 }}>
      <Stack gap={0.5}>
        {title && <Typography variant="subtitle2">{title}</Typography>}
        {items.map((item) => (
          <Box
            key={`${String(item.label)}-${String(item.value)}`}
            sx={{ alignItems: "center", display: "flex", gap: 1 }}
          >
            <Box
              sx={{
                backgroundColor: item.color,
                borderRadius: "50%",
                height: 8,
                width: 8,
              }}
            />
            <Typography color="text.secondary" variant="caption">
              {item.label}: {item.value}
            </Typography>
          </Box>
        ))}
        {footer && <Typography variant="caption">{footer}</Typography>}
      </Stack>
    </Paper>
  );
}
